import type { EntriesDev } from '../lib/types.js';

export function unstable_defineEntries(fns: EntriesDev['default']) {
  return fns;
}
